<script setup>
</script>
<template>
    <section class="text-gray-600 body-font">
        <div class="container 2xl:px-24 xl:px-0 mx-auto">
            <div class="pb-4 wow animate__animated animate__fadeInLeft">
                <h2
                    class="text-center text-black leading-tight mx-auto font-roboto title-font xl:text-[44px] lg:text-[36px] sm:text-[28px] text-xl lg:mt-4 sm:mb-6 mb-4">
                    {{ $t("about.board_director") }}</h2>
                <div class="mx-auto border-[3.5px] border-transparent border-t-[#1cbed1] w-36"></div>
            </div>
            <div
                class="grid grid-cols-1 lg:grid-cols-2 lg:gap-10 gap-6 xl:mt-12 sm:mt-6 xl:mb-12 mb-6 2xl:px-80 xl:px-72 lg:px-36 mx-auto">
                <div
                    class="rounded shadow-lg shadow-gray-300 mx-auto lg:w-full w-72  wow animate__animated animate__fadeInLeft">
                    <div class="lg:w-full w-72 sm:h-80 h-72 block rounded-t overflow-hidden">
                        <VLazyImage src="/assets/images/chairman.png" alt="charman of nac no chinta"
                            class="w-full lg:h-80 h-full object-cover transform hover:scale-110 transition duration-500" />
                    </div>
                    <div class="lg:p-4 p-2">
                        <div>
                            <h3 class="title-font lg:text-lg text-lg font-semibold text-black text-center mb-2">
                                {{ $t("chairman.name") }}</h3>
                            <div class="leading-relaxed mb-2 text-black text-center lg:text-lg text-base">
                                <p>{{ $t("chairman.position") }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <button data-modal-target="default-modal" data-modal-toggle="default-modal">
                    <div
                        class="rounded shadow-lg shadow-gray-300 mx-auto lg:w-full w-72  wow animate__animated animate__fadeInRight">
                        <div class="lg:w-full w-72 sm:h-80 h-72 block rounded-t overflow-hidden">
                            <VLazyImage src="/assets/images/hemica.jpg" alt="managing director of nac no chinta"
                                class="w-full lg:h-80 h-full object-cover transform hover:scale-110 transition duration-500" />
                        </div>
                        <div class="lg:p-4 p-2">
                            <div>
                                <h3 class="title-font lg:text-xl text-lg font-semibold text-black text-center mb-2">
                                    {{ $t("md.name") }}</h3>
                                <div class="leading-relaxed mb-2 text-black text-center lg:text-lg text-base">
                                    <p>{{ $t("md.position") }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </button>
                <div id="default-modal" tabindex="-1" aria-hidden="true"
                    class="rounded-md sm:overflow-x-hidden fixed right-0 left-0 z-50 justify-center items-center w-full md:inset-0 hidden">
                    <div class="relative p-4 w-full max-w-2xl max-h-full">
                        <div
                            class="h-screen overflow-auto scroll-smooth relative bg-white rounded-lg shadow dark:bg-gray-700">
                            <button type="button"
                                class="text-gray-800 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center float-right dark:hover:bg-gray-600 dark:hover:text-white"
                                data-modal-hide="default-modal">
                                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 14 14">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                </svg>
                                <span class="sr-only">Close modal</span>
                            </button>
                            <div class="flex justify-center items-center p-4 rounded-md">
                                <div class="mx-auto">
                                    <div class="w-[250px] h-[250px] flex items-center justify-center mx-auto">
                                        <VLazyImage src="/assets/images/hemica.jpg" alt="managing director of nac no chinta" class="h-full w-full object-cover object-top inline-block" />
                                    </div>
                                    <h4
                                        class="text-center title-font text-2xl font-semibold text-black mt-1 leading-relaxed">
                                        Rahman Abanti Hemica</h4>
                                    <p class="text-center text-gray-600 text-base font-light">Founder and Managing
                                        Director of No Chinta ltd</p>
                                </div>
                            </div>
                            <div class="p-5 space-y-4">
                                <p class="text-sm leading-relaxed text-black font-light font-roboto">
                                    A Visionary Leader in Healthcare and Entrepreneurship Rahman Abanti Hemica, a
                                    renowned healthcare visionary and entrepreneur, has dedicated her life to
                                    transforming the healthcare landscape in Bangladesh and beyond. With an unwavering
                                    commitment to improving the lives of others, she has built a remarkable career that
                                    spans across various sectors, including healthcare, technology, and social
                                    innovation.
                                </p>
                                <p class="text-sm leading-relaxed text-black font-light font-roboto">
                                    <span class="font-semibold">Early Life and Education:</span> Born and raised in
                                    Dhaka, Bangladesh, Rahman Abanti Hemica was an inquisitive and ambitious child. She
                                    displayed a strong passion for science and innovation from a young age. After
                                    completing his secondary education from Viqarunnisa Noon Dhaka in Dhaka, Ms Hemica
                                    pursued higher education in China. She earned a Bachelor's degree in Architectural
                                    Engineering from South East University Nanjing which is one of the most prestigious
                                    universities in China for pursuing Architectural Studies. Following the enriching
                                    experience, she traveled to the United States to further her education by pursuing
                                    master’s degree in Business Administration (MBA)
                                </p>

                                <p class="text-sm leading-relaxed text-black font-light font-roboto">
                                    <span class="font-semibold">Career and Accomplishments:</span> Upon completing her
                                    higher studies, Abanti Hemica joined her family business as a Director of Finance in
                                    One Pharma. After working in the family own pharmaceuticals company, she recognized
                                    the immense potential for innovation in the country's healthcare sector. She founded
                                    a startup No Chinta Home Healthcare Service, a pioneering home healthcare company
                                    that has since become a leader in providing high-quality, affordable, and accessible
                                    care to the elderly and individuals with chronic conditions. Through his leadership
                                    and vision, No Chinta has expanded its services to include clinical care at home,
                                    remote patient monitoring, and specialized care for elderly and children, among
                                    others. Hemica's dedication to advancing healthcare has not gone unnoticed. He has
                                    received numerous accolades and recognition for his achievements, including
                                    collaboration with the largest telecom company, private banks and university.
                                    Additionally, his company, No Chinta, has garnered several recognitions due to the
                                    innovative approach to home healthcare and its positive impact on the lives of
                                    countless individuals.
                                </p>

                                <p class="text-sm leading-relaxed text-black font-light font-roboto">
                                    <span class="font-semibold">Philanthropy and Social Impact:</span> Rahman Abanti
                                    Hemica is a firm believer in giving back to his community. She has established a
                                    charitable foundation HAH that focuses on providing healthcare services and
                                    education to underserved populations in Bangladesh. Her philanthropic endeavors have
                                    improved access to essential medical care, as well as created opportunities for
                                    aspiring healthcare professionals through scholarships and training programs.
                                </p>

                                <p class="text-sm leading-relaxed text-black font-light font-roboto">
                                    <span class="font-semibold">Personal Life:</span> Rahman Abanti Hemica is a devoted
                                    daughter and an amazing friend. She is known for his humility, kindness, and
                                    unwavering commitment to improving the lives of others. In her free time, Hemica
                                    enjoys reading, traveling, horse riding, skiing and spending quality time with her
                                    family.
                                </p>

                                <p class="text-sm leading-relaxed text-black font-light font-roboto">
                                    <span class="font-semibold">Legacy and Vision:</span> Rahman Abanti Hemica continues
                                    to be a driving force in transforming the healthcare landscape in Bangladesh and
                                    beyond. Her dedication, vision, and passion for innovation serve as an inspiration
                                    to aspiring entrepreneurs and healthcare professionals worldwide. With his ongoing
                                    efforts, Rahman Abanti Hemica aims to create a future where quality healthcare is
                                    accessible, affordable, and available to everyone, regardless of their
                                    circumstances, geographical location and income status.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped></style>
